import { useCallback } from 'react';
import useGetCurrentAliasSetQuery from '@src/hooks/api/queries/useGetCurrentAliasSetQuery';
import useAliasGroupContext from './context/useAliasGroup';
import { AliasGroups } from '@src/contextProviders/AliasGroup';

function useAlias() {
  const { data } = useGetCurrentAliasSetQuery();
  const [aliasGroup] = useAliasGroupContext();

  const isDefaultGroup =
    aliasGroup === AliasGroups.DEFAULT || !data?.aliasSet?.[aliasGroup];

  return useCallback(
    (text: string, params?: Record<string, string | number>) => {
      const translated = isDefaultGroup
        ? text
        : data?.aliasSet?.[aliasGroup]?.[text] || text;

      if (!params) {
        return translated;
      }
      // Replace {key} patterns with param values
      return Object.entries(params).reduce((str, [key, value]) => {
        return str.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
      }, translated);
    },
    [isDefaultGroup, data?.aliasSet, aliasGroup],
  );
}

export default useAlias;
